__turbopack_context__.v({
  "banner": "styles-module__cb04lG__banner",
  "boldText": "styles-module__cb04lG__boldText",
  "label": "styles-module__cb04lG__label",
});
